<template>
    <div
        class="mb-3 overflow-hidden"
        :class="{'border-b border-solid':hasDivided}"
    >
        <div
            v-if="hasTitle"
            class="my-5 shine w-1/3 md:w-1/5"
        />
        <!-- 內容 -->
        <div
            v-if="contentCols"
            :class="[{'grid grid-flow-col':contentCols},`md:grid-cols-${contentCols}`]"
        >
            <template
                v-for="i in contentCols"
                :key="i"
            >
                <div v-if="content">
                    <template
                        v-for="n in content"
                        :key="n"
                    >
                        <div
                            v-if="n%2!==0"
                            class="mb-3.5 shine w-3/5 md:w-1/4"
                        />
                        <div
                            v-else
                            class="mb-3.5 shine w-2/5 md:w-1/2"
                        />
                    </template>
                </div>
            </template>
        </div>
        <div v-else-if="content">
            <template
                v-for="n in content"
                :key="n"
            >
                <div
                    v-if="n%2!==0"
                    class="mb-3.5 shine w-3/5 md:w-1/4"
                />
                <div
                    v-else
                    class="mb-3.5 shine w-2/5 md:w-1/2"
                />
            </template>
        </div>
        <div v-if="hasInput">
            <div class="shine w-full h-10 rounded-sm mr-2.5" />
        </div>
        <!-- table -->
        <div
            v-if="table"
            class="mb-5"
        >
            <div class="md:shadow-3 rounded shine h-10" />
            <div class="grid grid-cols-3 gap-3 md:gap-4 my-3">
                <template
                    v-for="n in table"
                    :key="n"
                >
                    <template v-if="n%2!==0">
                        <div class="shine w-3/4 md:w-1/2" />
                        <div class="shine w-3/4 md:w-2/5" />
                        <div class="shine w-4/5" />
                    </template>
                    <template v-else>
                        <div class="shine w-1/2 md:w-1/3" />
                        <div class="shine w-3/5" />
                        <div class="shine w-1/2 md:w-2/5" />
                    </template>
                </template>
            </div>
        </div>
        <!-- 開合按鈕 -->
        <div
            v-if="hasButton"
            class="flex justify-end"
        >
            <div class="mb-3.5 shine w-12" />
        </div>
    </div>
</template>
<script>
export default {
    props: {
        hasTitle: {
            type: Boolean,
            default: false,
        },
        hasButton: {
            type: Boolean,
            default: false,
        },
        contentCols: {
            type: Number,
            default: 0,
        },
        content: {
            type: Number,
            default: 0,
        },
        table: {
            type: Number,
            default: 0,
        },
        hasInput: {
            type: Boolean,
            default: false,
        },
        hasDivided: {
            type: Boolean,
            default: false,
        }
    },
};
</script>
<style scoped>
.shine {
    @apply rounded-lg;
}
</style>
